import React, { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { useParams, useHistory } from "react-router-dom";

import BuRunCharges_Service from "../../../../services/buRunChargeServices";
import BuRunChargeForm from "./forms/BURunChargeForm";

function BuRunAddEdit() {
  debugger;
  const { id } = useParams();
  let history = useHistory();

  const [formData, setData] = useState({
    burctC_ID: 0,
    BU: "",
    Col1: "",
    Col3: "",
    Col5: "",
    LTM: "",
    RunChargeType: "",
    Lookup: "",
    active: false,
  });

  const getData = async () => {
    debugger;
    const result = await BuRunCharges_Service.getOne(id);
    if (result) setData(result);
  };

  useEffect(() => {
    getData();
  }, []);

  const saveHandler = async (data) => {
    const postData = {
      ID: id,
      BU: data.bu,
      Col1: data.col1,
      Col3: data.col3,
      Col5: data.col5,
      LTM: data.ltm,
      RunChargeType: data.runChargeType,
      Lookup: data.lookup,
    };

    if (id) {
      debugger;
      const result = await BuRunCharges_Service.update(postData);
      if (result.success === true) {
        history.goBack();
      }
    } else {
      debugger;
      const result = await BuRunCharges_Service.add(postData);
      if (result.success === true) {
        history.goBack();
      }
    }
  };

  return (
    <div>
      <h4>{id ? "Edit" : "New"} BU Run Charge</h4>
      <hr />
      <BuRunChargeForm formData={formData} submitForm={saveHandler} />
    </div>
  );
}

export default BuRunAddEdit;
